module.exports = __webpack_public_path__ + "static/media/melion.6f85be79.png";